module.exports = __webpack_public_path__ + "img/instrumenty-4.45a7d564.jpg";